module.exports = __webpack_public_path__ + "img/speaker-1-3.aae3b0c1.jpg";